import { inject } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivateFn, RouterStateSnapshot, UrlTree } from "@angular/router";
import Keycloak from "keycloak-js";
import { NavigationService } from "../services/navigation.service";

export const roleGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  _: RouterStateSnapshot): boolean | UrlTree => {

  const keycloak = inject(Keycloak);
  const requiredRole = route.data['roles'];
  let checkRole = false;
  for (let i = 0; i < requiredRole.length && !checkRole; i++) {
    checkRole = requiredRole.some((role:any) => keycloak.hasRealmRole(role));
  }
  if (!checkRole) {
    const navigationService = inject(NavigationService);
    navigationService.goTo(['/401']);
  }

  return checkRole;
}

